import React from 'react';
import '../Styles/AboutTheChange.css';

const AboutTheChange = () => {
  return (
    <section className="about-change-section">
      <div className="about-change-container">
        <h2>Patients Are Choosing in-home Convenience</h2>
        
        <ul className="demand-list">
          <li>Patients increasingly request flexible, in-home service options</li>
          <li>Women prioritize privacy and scheduling flexibility</li>
          <li>Group aesthetic bookings and private events continue growing in cities and suburban markets</li>
          <li>Clinics that offer convenience capture premium pricing</li>
        </ul>

        <p className="demand-source">
          Convenience is a leading driver in healthcare decisions.<br />
          <span className="source-citation">(Source: Deloitte Consumer Health Survey)</span>
        </p>
      </div>
    </section>
  );
};

export default AboutTheChange;
